import { render, staticRenderFns } from "./import-delete-dialog.vue?vue&type=template&id=8af62670&scoped=true"
import script from "./import-delete-dialog.vue?vue&type=script&lang=js"
export * from "./import-delete-dialog.vue?vue&type=script&lang=js"
import style0 from "./import-delete-dialog.vue?vue&type=style&index=0&id=8af62670&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af62670",
  null
  
)

export default component.exports